import React, { useContext } from "react";
import { IconButton, Modal, Portal } from "react-native-paper"
import { theme } from "../../theme/theme";
import { DimensionsContext } from "../../utils/mobileUtils";
import { useSelector } from "react-redux"

export const ModalM = (props) => {
    const {visible, onDismiss, children, style, dismissable = true, takeFullScreenWidth = false, withExitButton = false} = props
    const dimensions = useContext(DimensionsContext)

    const activityCameraOn = useSelector(state => state.activity?.cameraOn)

    return <Portal>
        <DimensionsContext.Provider
            value={{width: dimensions?.width, height: dimensions?.height}}>
            <Modal visible={visible && !activityCameraOn}
                   dismissable={dismissable}
                   onDismiss={onDismiss}
                   theme={{
                       colors: {
                           backdrop: theme.colors.blackTransparent2
                       }
                   }}
                   contentContainerStyle={{
                       alignSelf: "center",
                       backgroundColor: theme.colors.white,
                       borderRadius: 10,
                       overflow: 'hidden',
                       elevation: 10,
                       zIndex: 10,
                       width: takeFullScreenWidth ? dimensions?.width + 20 : dimensions?.width - 50,
                       // position: IS_WEB ? "fixed" : null,
                       // top: IS_WEB ? 0 : null,
                       ...style
                   }}
            >
                {children}
                {withExitButton && <IconButton
                    icon={'times'}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{
                        position: 'absolute',
                        right: 5,
                        top: 5
                    }}
                    onPress={onDismiss}
                />}
            </Modal>
        </DimensionsContext.Provider>
    </Portal>
}